import * as lexActionType from '../actionsType/lexFavourite.actionType';

export const initialState = {
    response: null,
    exception: null
};

export function favouriteReducer(state = initialState, action) {
    switch (action.type) {
        case lexActionType.LEX_FAVORITE_SUCCESS:
            return {...state, response: action.payload};
        case lexActionType.LEX_FAVORITE_ERROR:
            return {...state, exception: lexActionType.LEX_FAVORITE_ERROR};
        default:
            return state;
    }
}
